// APIs used, TODO: maybe use secrets manager for this
export const scan_api = "https://3q2auuz639.execute-api.us-east-1.amazonaws.com/alpha/scan";
export const scan_alias_api = "https://4cw0k4c0b1.execute-api.us-east-1.amazonaws.com/alpha/scan_alias";
export const create_api = "https://mqbgr6rn5m.execute-api.us-east-1.amazonaws.com/alpha/create";
export const TPPSDiscoveryDataInternal="https://i23npw7f13.execute-api.us-east-1.amazonaws.com/dev/getinternal";
export const TPPSDiscoveryDataInsert="https://lhfj0phz0h.execute-api.us-east-1.amazonaws.com/Dev/create";
export const post_product_eval="https://uwpe7j14aj.execute-api.us-east-1.amazonaws.com/staging/productev";
export const create_api2 = "https://n3a7wfok7j.execute-api.us-east-1.amazonaws.com/DeployStageDev/registerinst";
